import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type CitiLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const citiConfig: BankLogoConfig = {
    colors: {
        background: '#263971',
        logo: 'white',
    },
    defaultAlt: 'Citi Bank Logo',
};

const renderCitiLogo = (colors: { background: string; border?: string; logo: string }) => (
    <>
        <path
            d="M24.196 39.9006L24.1225 39.9718C22.9677 41.1485 21.6313 41.7701 20.2548 41.7701C17.3798 41.7701 15.2943 39.6133 15.2943 36.6384C15.2943 33.6682 17.3798 31.5079 20.2548 31.5079C21.6313 31.5079 22.9677 32.133 24.1225 33.3143L24.196 33.3843L26.0448 31.1483L25.9954 31.0885C24.458 29.2719 22.6126 28.3883 20.3444 28.3883C18.0704 28.3883 15.9883 29.1547 14.49 30.5347C12.8583 32.0308 12 34.1404 12 36.6384C12 39.1365 12.8583 41.2507 14.49 42.7468C15.9883 44.1348 18.0704 44.8955 20.3444 44.8955C22.6126 44.8955 24.458 44.0107 25.9954 42.1929L26.0448 42.1378L24.196 39.9006Z"
            fill={colors.logo}
        />
        <path d="M27.9121 44.5918H31.1777V28.6476H27.9121V44.5918Z" fill={colors.logo} />
        <path
            d="M43.9715 41.1243C43.0994 41.6552 42.2893 41.9229 41.5608 41.9229C40.5049 41.9229 40.0269 41.3645 40.0269 40.1235V31.6631H43.3557V28.6617H40.0269V23.7002L36.8268 25.4145V28.6617H34.0645V31.6631H36.8268V40.6624C36.8268 43.1133 38.2792 44.7909 40.4486 44.8346C41.9205 44.8633 42.8076 44.4244 43.3453 44.1027L43.3798 44.0808L44.1646 41.006L43.9715 41.1243Z"
            fill={colors.logo}
        />
        <path d="M46.6758 44.5918H49.946V28.6476H46.6758V44.5918Z" fill={colors.logo} />
        <path
            d="M51.8497 25.8522C48.8656 21.626 43.9109 19.105 38.8701 19.105C33.8303 19.105 28.8745 21.626 25.8962 25.8522L25.7422 26.0693H29.4996L29.5409 26.0245C32.0976 23.384 35.4367 21.9891 38.8701 21.9891C42.3034 21.9891 45.6403 23.384 48.2026 26.0245L48.244 26.0693H51.9991L51.8497 25.8522Z"
            fill="#EE1C25"
        />
    </>
);

/**
 * Citi Bank logo component with flexible sizing and color variants
 */
function CitiLogo(props: CitiLogoProps) {
    return <BaseBankLogo {...props} config={citiConfig} renderLogo={renderCitiLogo} />;
}

export default CitiLogo;
